export const status = {
  APPROVED: 'Approved',
  SUBMITTED: 'Submitted',
  SAVED: 'Saved',
  REJECTED: 'Rejected',
};
